/**
 * Generated With: pnpm x packages/api/tools/generate-shopify-rest-model.ts
 */

import { FieldType } from "../../type-system/FieldType";
import {
  ShopifyBillingAddressKey,
  ShopifyDisputeEvidenceCancellationPolicyFileKey,
  ShopifyDisputeEvidenceCustomerCommunicationFileKey,
  ShopifyDisputeEvidenceFulfillmentKey,
  ShopifyDisputeEvidenceFulfillmentToDisputeEvidenceKey,
  ShopifyDisputeEvidenceKey,
  ShopifyDisputeEvidenceRefundPolicyFileKey,
  ShopifyDisputeEvidenceServiceDocumentationFileKey,
  ShopifyDisputeEvidenceShippingDocumentationFileKey,
  ShopifyDisputeEvidenceToDisputeKey,
  ShopifyDisputeEvidenceToShopKey,
  ShopifyDisputeEvidenceUncategorizedFileKey,
  ShopifyDisputeFileUploadKey,
  ShopifyDisputeFileUploadToDisputeEvidenceKey,
  ShopifyDisputeKey,
  ShopifyShippingAddressKey,
  ShopifyShopKey,
} from "./keys";
import { ShopifyApiVersion } from "./ShopifyApiVersion";
import { ShopifyDominion } from "./ShopifyDominion";
import type { ConnectionModelSpecVersion } from "./ShopifyMetadata";
import { buildConnectionSpec } from "./ShopifyMetadata";

const specs: ConnectionModelSpecVersion = {
  key: ShopifyDisputeEvidenceKey,
  "2022-07": {
    name: "Shopify Dispute Evidence",
    fields: [
      {
        name: "Id",
        fieldType: FieldType.ID,
        contributorConfiguration: {
          [ShopifyDominion.id]: { graphQLFieldKey: "id" },
        },
      },
      {
        name: "Dispute",
        fieldType: FieldType.BelongsTo,
        key: ShopifyDisputeEvidenceToDisputeKey,
        contributorConfiguration: {
          // we need to skip this selection because we can't sync this with existing sync types and we don't want to overwrite the data from the graphQL sync
          [ShopifyDominion.id]: { graphQLFieldKey: "dispute", graphQLSelection: "id", skipGraphQLSelection: true },
        },
        configuration: {
          relatedModelKey: ShopifyDisputeKey,
        },
      },
      {
        name: "Shipping Address",
        fieldType: FieldType.HasOne,
        contributorConfiguration: {
          [ShopifyDominion.id]: { graphQLFieldKey: "shippingAddress", graphQLSelection: "id" },
        },
        configuration: {
          relatedModelKey: ShopifyShippingAddressKey,
        },
      },
      {
        name: "Billing Address",
        fieldType: FieldType.HasOne,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "billingAddress", graphQLSelection: "id" },
        },
        configuration: {
          relatedModelKey: ShopifyBillingAddressKey,
        },
      },
      {
        name: "Customer Email Address",
        fieldType: FieldType.Email,
        contributorConfiguration: {
          [ShopifyDominion.id]: { graphQLFieldKey: "customerEmailAddress" },
        },
      },
      {
        name: "Customer First Name",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { graphQLFieldKey: "customerFirstName" },
        },
      },
      {
        name: "Customer Last Name",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { graphQLFieldKey: "customerLastName" },
        },
      },
      {
        name: "Product Description",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { graphQLFieldKey: "productDescription" },
        },
      },
      {
        name: "Uncategorized Text",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { graphQLFieldKey: "uncategorizedText" },
        },
      },
      {
        name: "Submitted By Merchant On",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "submitted_by_merchant_on" },
        },
      },
      {
        name: "Fulfillments",
        fieldType: FieldType.HasMany,
        configuration: {
          dependent: "delete",
          relatedModelKey: ShopifyDisputeEvidenceFulfillmentKey,
          inverseFieldKey: ShopifyDisputeEvidenceFulfillmentToDisputeEvidenceKey,
        },
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "fulfillments",
            graphQLSelection: "id shippingCarrier shippingDate shippingTrackingNumber",
          },
        },
      },
      {
        name: "Cancellation Policy File",
        key: ShopifyDisputeEvidenceCancellationPolicyFileKey,
        fieldType: FieldType.HasOne,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "cancellationPolicyFile",
            graphQLSelection: "disputeEvidenceType fileSize fileType id originalFileName url",
          },
        },
        configuration: {
          dependent: "delete",
          relatedModelKey: ShopifyDisputeFileUploadKey,
          inverseFieldKey: ShopifyDisputeFileUploadToDisputeEvidenceKey,
        },
      },
      {
        name: "Customer Communication File",
        key: ShopifyDisputeEvidenceCustomerCommunicationFileKey,
        fieldType: FieldType.HasOne,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "customerCommunicationFile",
            graphQLSelection: "disputeEvidenceType fileSize fileType id originalFileName url",
          },
        },
        configuration: {
          dependent: "delete",
          relatedModelKey: ShopifyDisputeFileUploadKey,
          inverseFieldKey: ShopifyDisputeFileUploadToDisputeEvidenceKey,
        },
      },
      {
        name: "Refund Policy File",
        key: ShopifyDisputeEvidenceRefundPolicyFileKey,
        fieldType: FieldType.HasOne,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "refundPolicyFile",
            graphQLSelection: "disputeEvidenceType fileSize fileType id originalFileName url",
          },
        },
        configuration: {
          dependent: "delete",
          relatedModelKey: ShopifyDisputeFileUploadKey,
          inverseFieldKey: ShopifyDisputeFileUploadToDisputeEvidenceKey,
        },
      },
      {
        name: "Service Documentation File",
        key: ShopifyDisputeEvidenceServiceDocumentationFileKey,
        fieldType: FieldType.HasOne,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "serviceDocumentationFile",
            graphQLSelection: "disputeEvidenceType fileSize fileType id originalFileName url",
          },
        },
        configuration: {
          dependent: "delete",
          relatedModelKey: ShopifyDisputeFileUploadKey,
          inverseFieldKey: ShopifyDisputeFileUploadToDisputeEvidenceKey,
        },
      },
      {
        name: "Shipping Documentation File",
        key: ShopifyDisputeEvidenceShippingDocumentationFileKey,
        fieldType: FieldType.HasOne,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "shippingDocumentationFile",
            graphQLSelection: "disputeEvidenceType fileSize fileType id originalFileName url",
          },
        },
        configuration: {
          dependent: "delete",
          relatedModelKey: ShopifyDisputeFileUploadKey,
          inverseFieldKey: ShopifyDisputeFileUploadToDisputeEvidenceKey,
        },
      },
      {
        name: "Uncategorized File",
        key: ShopifyDisputeEvidenceUncategorizedFileKey,
        fieldType: FieldType.HasOne,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "uncategorizedFile",
            graphQLSelection: "disputeEvidenceType fileSize fileType id originalFileName url",
          },
        },
        configuration: {
          dependent: "delete",
          relatedModelKey: ShopifyDisputeFileUploadKey,
          inverseFieldKey: ShopifyDisputeFileUploadToDisputeEvidenceKey,
        },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyDisputeEvidenceToShopKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "shop_id" },
        },
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
    ],
    // synced as part of ShopifyDispute
    syncConfig: { type: "inherit" },
  },
};

export const ShopifyDisputeEvidence = ({
  apiVersion,
  frameworkVersionConstraint,
  webhookTopicsForModel,
}: {
  apiVersion: ShopifyApiVersion;
  frameworkVersionConstraint?: string;
  webhookTopicsForModel?: string[];
}) => buildConnectionSpec(specs, apiVersion, frameworkVersionConstraint, webhookTopicsForModel);
